import type { QueryClient } from '@tanstack/react-query';
import type { components } from 'src/infrastructure/rest-api/generated';

type NotificationPayload = components['schemas']['NotificationPayload'];

export const invalidateNotification = (queryClient: QueryClient, payload: NotificationPayload): void => {
    switch (payload.entity) {
        case 'Announcement':
            void queryClient.invalidateQueries({ queryKey: ['/api/announcements'] });
            break;
        case 'PipelineRunStatus':
            void queryClient.invalidateQueries({ queryKey: ['/api/pipelinestatus'] });
            break;
    }
};
